import type {
  SYSColumnDef,
  SYSTableDef,
} from "../../../../../library/table/tableapi"

export type SYSTableSettings_FilterSort = {
  Code?: string
  U_Desc?: string
  // CanBeUsedBy will be a list: User/Company A/Company B/.../All
  // whereas User means is just valid for the USer, Company A _> its valid for all Users of Company A, All -> valid for all Users
  CanBeUsedBy?: string
  U_FilterSortSettings?: string
  U_CntctCode?: number
}

export type SYSTableSettings_FilterSortSelect = {
  Code?: string
  CardName?: string
  U_Desc?: string
  // CanBeUsedBy will be a list: User/Company A/Company B/.../All
  // whereas User means is just valid for the USer, Company A _> its valid for all Users of Company A, All -> valid for all Users
  CanBeUsedBy?: "@@SYSAll" | "@@SYSUser" | string
  UserCompanyName?: string
  UserName?: string
  U_CntctCode?: number
}

let columns: { [key in keyof SYSTableSettings_FilterSort]: SYSColumnDef } = {
  U_Desc: {
    sortable: true,
    ui: { labelTranslationKey: "SYSTableSettingsFilterSortColName" },
    schema: { nullable: false },
  },

  CanBeUsedBy: {
    filter: { columnFilter: { type: "none" } },
    schema: { nullable: false },
    sortable: true,
    ui: { labelTranslationKey: "SYSTableSettingsFilterSortColCanBeUsedBy" },
    list: {
      valueField: "Val",
      displayField: "Desc",
    },
  },

  U_CntctCode: {
    filter: { columnFilter: { type: "none" } },
    sortable: true,

    type: "int",
    list: {
      valueField: "Val",
      displayField: "Desc",
      displayValueField: false,
    },
    ui: { labelTranslationKey: "SYSTableSettingsFilterSortColU_CntctCode" },
  },
}

export let tblTableSettings_FilterSort: SYSTableDef = {
  feature: "SYSTableSettings",
  id: "SYSTableSettings_FilterSort",
  title: { dialogTitle: { doNotDisplayId: true } },
  database: {
    dataIdField: "Code",
    dbInsertMode: "AutoGUID",
  },
  server: {
    endpoint: "tablesettings/filtersort",
  },
  options: {
    rendering: {
      tableControls: {
        page: { visible: false },
        add: { visible: false },
        resetFilter: { visible: false },
        resetSort: { visible: false },
        rebuild: { visible: false },
        more: { visible: false },
        close: { visible: false },
        customFns: { visible: false },
      },
    },
    initial_sort: { field: "Name", direction: "asc" },
  },
  features: {
    delete: true,
    edit: true,
  },
  columns,
}
